module.exports = __webpack_public_path__ + "static/media/Ticket.a13a148b.svg";